import { useQuery } from "@tanstack/react-query";
import { useAppData } from "../context/Contexts";

const useCustomProductQuery = () => {
    const { currentAppData, setCurrentAppData } = useAppData();

    const {
        status,
        data,
        error,
        isFetching,
        refetch
    } = useQuery({
        queryKey: ['productCustom'],
        refetchOnWindowFocus: false,
        enabled: false,
        queryFn: () => fetchCustomProduct(),
    }
    )

    const Shopify = window.Shopify || {};
    Shopify.country = Shopify.country || 'US';
    const defaultQuery = (opts) => {
        const q = `
      query @inContext(country: ${Shopify.country}) {
        
  product(id: "gid://shopify/Product/${import.meta.env.VITE_SHOPIFY_CUSTOM_PRODUCT_ID}") {
    id
    title
    handle
    availableForSale
    createdAt
    productType
    tags
    collections(first: 5) {
      edges {
        node {
          id
          title
        }
      }
    }
    images(first: 100) {
      edges {
        node {
          id
          url
          altText
        }
      }
    }
    options {
        id
        name
        optionValues {
            name
            id
        }
    }
    variants(first: 100) {
      edges {
        node {
          id
          sku
          availableForSale
          title
          currentlyNotInStock
          selectedOptions {
            name
            value
          }
          image {
            id
            url
          }
          priceV2 {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          
        }
      }
    }
  }
}`;

        return q;
    }

    const buildQuery = (opts) => {

        const q = defaultQuery({ ...opts })

        return q;
    }

    const fetchCustomProduct = async (pageParam = null) => {
        //console.log(key);
        // console.log('pageParam: ');
        // console.log(pageParam);

        const myHeaders = new Headers();
        myHeaders.append("X-Shopify-Storefront-Access-Token", import.meta.env.VITE_SHOPIFY_STOREFRONT_TOKEN);
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
            query: buildQuery({}),
            variables: { "after": "" }
        })
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: graphql,
            redirect: 'follow'
        };

        const response = await fetch(import.meta.env.VITE_SHOPIFY_STORE_URL, requestOptions)
            .catch(error => console.error('error', error));

        const data = await response.json();

        setCurrentAppData(prevState => {
            return { ...prevState, product: data.data.product }
        });

        return data.data.product
    }

    return {custom_status: status,
        custom_data: data,
        custom_error: error,
        custom_isFetching: isFetching,
        custom_refetch: refetch};
};

export default useCustomProductQuery;